import { AuthCard } from '@/components/domain/auth/AuthCard';
import { AuthLayout } from '@/components/domain/auth/AuthLayout';
import {
  DateFormFieldBuilder,
  FieldsGroupFormFieldBuilder,
} from '@/forms/builders';
import { DynamicForm, LoginFormPresenter } from '@/forms/components';
import { useDynamicForm } from '@/forms/hooks';
import { FormDomain, FormInitialValues } from '@/forms/typings';

const TEST_FORM = new FieldsGroupFormFieldBuilder()
  .fieldId('test-group')
  .name('Alternative Address')
  .fields([
    new DateFormFieldBuilder()
      .fieldId('test-date')
      .name('test-date')
      .label('Select a date')
      .size(12)
      .build(),
  ])
  .isCollapsible(true)
  .build();

export const TestPage: React.FC = () => {
  const testFormData = useDynamicForm([TEST_FORM]);

  const onSubmit = (values: FormInitialValues) => {
    console.log('Form submitted with values:');
    console.table(values);
  };

  return (
    <AuthLayout>
      <AuthCard title="Test Page">
        <DynamicForm
          domain={FormDomain.Unknown}
          {...testFormData}
          onSubmit={onSubmit}
        >
          <LoginFormPresenter uniqueKey="test-form" />
        </DynamicForm>
      </AuthCard>
    </AuthLayout>
  );
};
